const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        },
        titulo: "Dashboard",
        summaryBanner: "Showing data from {{from}} to {{to}} for {{userName}}",
        filters: {
          title: "Filters",
          show: "Show filters",
          hide: "Hide filters"
        }
      },
      connections: {
        outboundPause: {
          chip: "SENDING PAUSED",
          switchLabel: "Outgoing messages",
          active: "Active",
          paused: "PAUSED",
          pausedHelp: "No message goes out through this connection: not from chat, AI, templates or reminders. They stay in the chat marked as not sent.",
          confirmTitle: "Pause sending on {{name}}?",
          confirmMessage: "While paused, NO message will go out through this connection: chat replies, AI replies, templates, appointment confirmations and reminders. Incoming messages are still received. Remember to resume it.",
          confirmButton: "Pause sending",
          toastPaused: "Sending on {{name}} PAUSED.",
          toastResumed: "Sending on {{name}} resumed.",
        },
        title: "Connections",
        empty: "No connections yet.",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
          restarted: "Connection restarted successfully",
          newDefault: "{{name}} is now your default connection.",
        },
        defaultChanged: {
          message: "Your default connection changed to {{name}}. If you want another, change it here.",
          change: "Change",
          ack: "Got it",
        },
        metaHealth: {
          checking: "Checking status…",
          refresh: "Refresh status",
          blockingChip: "Blocks sending",
          blockingNote: "This prevents your number from sending messages until you fix it.",
          nonBlockingNote: "Doesn't stop things from working, but worth fixing.",
          ok: { title: "Connection active", desc: "Your Meta number is ready to send and receive." },
          billing_missing: { title: "Payment not set up", desc: "Your number CANNOT send messages until you set up a payment method in Meta. This is what's blocking sending right now.", descDetected: "We detected that Meta rejected a send due to a missing payment method. If you already added a card, try sending again; if it keeps failing, check the Billing Center.", action: "Set up payment" },
          payment_unverified: { title: "We can't verify the payment method", desc: "We haven't confirmed a successful send with this number yet. If a send fails, it may be because a card hasn't been added in Meta.", action: "Check payment" },
          register_needed: { title: "Number activation pending", desc: "Your number is verified but not yet activated to send. We can activate it from here.", action: "Retry registration", retrying: "Activating…", retryOk: "Number activated. Refreshing status…", retryFail: "Could not activate the number. Try again in a moment." },
          pending: { title: "Meta is reviewing your number", desc: "Meta is still verifying your number. It may take a while; there's nothing to do on your end for now." },
          name_declined: { title: "Display name declined", desc: "Meta declined the number's display name. This does NOT block sending or receiving messages; still worth changing it to improve delivery: on the number's screen, go to Profile → Display name.", action: "Change name" },
          quality_low: { title: "Low number quality", desc: "Meta lowered your number's quality. You can still send and receive, but ease your sending pace to avoid losing eligibility." },
          no_templates: { title: "No approved templates", desc: "You have no approved templates. You can still reply normally within 24 hours, but you need a template to start new conversations outside that window.", action: "Create template" },
          check_failed: { title: "Could not verify", desc: "We couldn't check the status in Meta right now. Try refreshing in a moment." },
          qualityChip: "Quality: {{quality}}",
          quality: { GREEN: "High", YELLOW: "Medium", RED: "Low" },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
          disconnectMessageMeta: "Are you sure you want to disconnect this Meta connection?",
          restartTitle: "Restart connection",
          restartMessage: "Restart the connection? All data and settings will be preserved. The connection will reconnect and show a new QR code.",
          restartMessageMeta: "Retry the connection? All data and settings will be preserved. The Meta connection will be re-established.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connecting",
          restart: "Restart",
          templates: "Templates",
          edit: "Edit",
          delete: "Delete",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          disconnectedMeta: {
            title: "The Meta connection is not active",
            content:
              "The Meta connection is not active. Click 'Try Again' to re-establish it.",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          number: "Number",
          type: "Type",
          status: "Status",
          backup: "Backup",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
        badges: {
          primary: "PRIMARY",
          standby: "STANDBY",
          failover: "FAILOVER ACTIVE",
        },
        types: {
          qrPro: "WhatsApp QR — Pro",
          qrWeb: "WhatsApp QR — Web",
          metaCloud: "Meta Cloud API",
          coexistence: "Meta Coexistence",
          qrProDesc: "Stable and efficient. The recommended option for most.",
          qrWebDesc: "Maximum compatibility with all devices.",
          metaCloudDesc: "Official connection certified by Meta. Templates and bulk messaging.",
          coexistenceDesc: "Use WhatsApp from your phone and WAIA at the same time.",
          notEnabled: "Not enabled",
        },
        alerts: {
          primaryDown: "Connection {{name}} disconnected. Check the connections page.",
          primaryDownWithStandby: "Connection {{name}} disconnected. Using backup {{standby}} automatically.",
          standbyDown: "Backup {{name}} is unavailable. Only the primary connection remains.",
          primaryDownBothFailed: "Connection {{name}} and its backup {{standby}} are both disconnected.",
        },
        stepSelectType: "What type of connection do you want to add?",
        stepConfigure: "Configuration",
        noTypesEnabled: "No connection types are enabled for this company. Contact your administrator.",
        backupConnection: "Backup connection",
        noBackup: "No backup",
        backupOf: "Backup of:",
        unlinkBackup: "Unlink",
        allowedConnectionTypes: "Allowed connection types",
      },
      connectionBanner: {
        pausedPrefix: "SENDING PAUSED on",
        pausedSuffix: "No message goes out through that connection.",
        prefix: "The WhatsApp connection",
        statusDisconnected: "is disconnected",
        statusWaitingQr: "is waiting for QR",
        actionQr: "Scan the QR to reconnect.",
        actionMeta: "Retry the connection.",
        goToConnections: "Go to connections →",
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          n8nWebhookUrl: "n8n webhook for this connection (optional)",
          n8nWebhookUrlHelp: "If set, messages arriving on this line are sent to this webhook (a dedicated bot per line). Empty = uses the company webhook.",
          backupConnection: "Backup connection",
          noBackup: "No backup",
          backupOf: "This connection is backup of:",
          unlinkBackup: "Unlink",
          isPrimary: "This connection is the primary",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          next: "Next",
        },
        success: "WhatsApp saved successfully.",
        meta: {
          phoneNumberId: "Phone Number ID",
          wabaId: "WABA ID",
          appId: "App ID",
          accessToken: "Access Token",
          whereToFind: "Find it in Meta Business → WhatsApp → API Setup",
          updateToken: "Update token",
          tokenHidden: "Token saved ●●●●●●●●",
        },
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
          canSeeUnassigned: "See unassigned chats",
          canViewPhones: "Can view phone numbers", canViewPhonesHelper: "If off, this user sees contact phone numbers masked (e.g. +549351●●●●482). Administrators always see them in full.",
          allowedWhatsapps: "Allowed connections",
          allowedWhatsappsAll: "All connections",
          allowedWhatsappsHelp: "If none selected, the user will see chats from all connections.",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        noAccess: "You do not have access to this chat.",
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          deleted: { title: "Deleted" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
        selectQueueModal: {
          title: "From which department do you want to accept?",
          subtitle: "The ticket will be assigned to this department",
          confirm: "Confirm",
          cancel: "Cancel",
        },
        selectWhatsappModal: {
          title: "From which connection to send?",
          subtitle: "Select the WhatsApp connection",
          confirm: "Confirm",
          cancel: "Cancel",
        },
        acceptedSuccess: "Ticket accepted successfully",
      },
      transferTicketModal: {
        title: "Transfer conversation",
        fieldUser: "Assign to user (optional)",
        fieldUserPlaceholder: "Search user...",
        fieldQueue: "Department",
        fieldQueuePlaceholder: "Select department...",
        fieldConnection: "Connection",
        fieldNote: "Internal note (optional)",
        fieldNotePlaceholder: "Write a comment for the agent receiving the chat. Use / to insert quick replies.",
        fieldNoteHelper: "This note will be visible only to agents in the chat.",
        userNoQueueInfo: "This user has no department assigned. The conversation will be transferred without a department.",
        transferButton: "Transfer",
        cancelButton: "Cancel",
        disabledTooltip: "Select a user or department to continue",
        successToast: "Conversation transferred",
        noOptions: "No user found with this name",
        noteHeader: {
          title: "🔄 Transfer",
          fromTo: "From: {{from}} → {{to}}",
          toQueue: "Department {{queue}}",
        },
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        // feat_340: el CHIP del zócalo (no el tab).
        pendingChipLabel: "Unread",
        assignedHeader: "Working on",
        pendingHeaderShort: "Queue",
        assignedHeaderShort: "Active",
        noTicketsTitle: "Nothing here!",
        filters: {
          all: "All",
          unassigned: "Unassigned",
          none: "Filters",
          tags: "Tags",
          filtersLabel: "Filters:",
          tagPlaceholder: "Tag",
          tagCount: "{{count}} tags",
          tagCountOne: "1 tag",
          contactTypes: "Customer Type",
          contactTypePlaceholder: "Type",
          contactTypeCount: "Type: {{count}} selected",
          contactTypeCountOne: "1 type selected",
          queuePlaceholder: "Department",
          queueCount: "{{count}} departments",
          statePlaceholder: "State",
          userPlaceholder: "User",
          userCount: "{{count}} users",
          userUnassigned: "Unassigned",
        },
        noQueue: "No department",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        contactsWithoutChat: "Contacts without chat",
        startChat: "Start chat",
        group: "Group",
        buttons: {
          accept: "Accept",
        },
        deletedView: {
          restoreBtn: "Restore",
          restoreOne: "Restore this chat",
          hardDeleteBtn: "Delete permanently",
          hardDeleteOne: "Delete permanently",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        toastExisting: "Already chatting with {{name}} — opening existing chat",
        toastInOtherQueue: "Chat in queue \"{{queueName}}\" handled by {{userName}}. Ask for a transfer.",
        otherAgent: "another agent",
        inOtherQueueActive: "This chat is being handled by {{userName}} in the \"{{queueName}}\" queue. Ask them to transfer it to you.",
        inOtherQueueClosed: "This chat belongs to the \"{{queueName}}\" queue and you do not have access to it.",
        toastNoConnection: "No active WhatsApp connections available",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          crmBoard: "Funnel",
          dashboard: "Dashboard",
          announcements: "Announcements",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            darkMode: "Dark mode",
            density: "Density",
            densityCompact: "Compact",
            densityNormal: "Normal",
            densityComfortable: "Comfortable",
          },
        },
        sidebar: {
          pin: "Pin menu",
          unpin: "Unpin menu",
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      companies: {
        secretariaIaSuperadminLabel: "AI Secretary",
        secretariaIaSuperadminHelp: "Enables the AI Secretary for this company. If disabled, no AI will respond.",
        iaAdminCanToggleLabel: "Allow admin control",
        iaAdminCanToggleHelp: "If enabled, this company's admin can turn the AI on or off from their panel.",
      },
      ia: {
        toolbarActiveTooltip: "AI on — click to turn off",
        toolbarInactiveTooltip: "AI off — click to turn on",
        toolbarTurnosNote: "Secretary/Salesperson AI only: the TurnosIA assistant has its own switch (TurnosIA › Settings).",
        menuSecretariaLabel: "AI Secretary",
        menuVendedorLabel: "AI Salesperson",
        vendedorDisabledTooltip: "Enable the AI Secretary first",
      },
      settings: {
        success: "Settings saved successfully.",
        businessInfo: {
          title: "Business details",
          subtitle: "Information the AI uses in every conversation with customers.",
          address: "Address",
          phone: "Phone",
          whatsapp: "Support WhatsApp",
          email: "Contact email",
          locationLink: "Google Maps link",
          hoursText: "Opening hours (free text)",
          hoursTextHelp: "E.g. Mon-Fri 9am-6pm. Text the AI can read to the customer.",
          timezone: "Time zone",
        },
        businessHours: {
          title: "Business hours",
          always247Label: "Available 24/7",
          always247Helper: "If enabled, the company is considered always available regardless of the configured schedule.",
          scheduleLabel: "Opening hours",
          scheduleHelper: "Defines the days and hours the company is available to receive inquiries. Used for abandoned cart and other automations.",
        },
        title: "Settings",
        secretariaIaSuperadminLabel: "AI Secretary",
        secretariaIaSuperadminHelp: "Enables the AI Secretary for this company. If disabled, no AI will respond.",
        vendedorIaSuperadminLabel: "AI Salesperson",
        vendedorIaSuperadminHelp: "Enables the AI Salesperson. Requires the AI Secretary to be active.",
        iaAdminCanToggleLabel: "Allow admin control",
        iaAdminCanToggleHelp: "If enabled, the company admin can turn the AI on or off from their panel.",
        secretariaIaLabel: "AI Secretary",
        aiSilenceOnTicketOpenLabel: "Silence AI when the ticket is taken",
        aiSilenceOnTicketOpenHelp: "If enabled, when an agent takes (opens) a ticket the AI immediately stops replying to that contact, without waiting for the agent to type. Closing the ticket re-enables the AI.",
        aiActivateOnlyOnClose: "AI only on close",
        aiActivateOnlyOnCloseDesc: "If enabled, the AI does not respond during transfers between agents or departments. It only resumes when the ticket is closed and the contact writes again.",
        secretariaIaHelp: "Controls whether the AI Secretary replies to incoming messages.",
        vendedorIaLabel: "AI Salesperson",
        vendedorIaHelp: "Controls whether the AI Salesperson takes qualified contacts.",
        vendedorIaDisabledTooltip: "Enable the AI Secretary first",
        iaControlSectionTitle: "Artificial Intelligence",
        iaActiveStatus: "Current status",
        iaStatusOn: "On",
        iaStatusOff: "Off",
        iaScheduleSectionTitle: "Automatic AI schedule",
        iaScheduleEnabledLabel: "Turn AI on automatically after hours",
        iaScheduleEnabledHelp: "The AI will turn itself on when business hours end. It does not turn off automatically when hours begin.",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        forwarded: "Forwarded",
        unsupportedMessage: "Unsupported message",
        historyMediaUnavailable: "📎 File from history not available",
        forwardedMany: "Forwarded many times",
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        captionPlaceholder: "Add a caption...",
        cancelMedia: "Cancel",
        sendMedia: "Send",
        dropFileHere: "Drop file here",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketActionButtons: {
        exportTooltip: "Download conversation (TXT)",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete conversation with {{name}}?",
          message: "The chat will be moved to Deleted. You can restore it from there.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_CONTACT_IMPORT_EMPTY: "The file is empty or has no rows.",
        ERR_CONTACT_IMPORT_TOO_LARGE: "The file is larger than 5 MB.",
        ERR_CONTACT_IMPORT_TOO_MANY_ROWS: "The file has more than 10,000 rows. Split it into parts.",
        ERR_CONTACT_IMPORT_TOO_MANY_COLUMNS: "The file has too many columns (maximum 60).",
        ERR_CONTACT_IMPORT_NOT_CSV: "The file doesn't look like a CSV. If it's an Excel file, save it as CSV first.",
        ERR_CONTACT_IMPORT_BAD_OPTIONS: "Invalid import options.",
        ERR_CONTACT_IMPORT_BAD_MAPPING: "The column mapping is not valid.",
        ERR_CONTACT_IMPORT_DUPLICATE_FIELD: "Each field (name, number, email…) can come from only one column.",
        ERR_CONTACT_IMPORT_NUMBER_REQUIRED: "Choose the phone number column.",
        ERR_CONTACT_IMPORT_IN_PROGRESS: "An import is already running for your company. Wait for it to finish.",
        ERR_TICKET_TRANSFER_NOT_ALLOWED: "You are not allowed to transfer this ticket.",
        ERR_TICKET_NOT_ALLOWED: "You do not have access to this conversation.",
        ERR_QUEUE_NOT_FOUND: "Department not found.",
        ERR_CRM_DISABLED: "The Funnel is not enabled for this company.",
        ERR_SUPPORT_NOT_ALLOWED: "Only company administrators can use Support.",
        ERR_SUPPORT_DISABLED: "Support is not enabled for this company.",
        ERR_SUPPORT_FLAG_SUPERADMIN_ONLY: "Only the WAIA team can turn Support on or off.",
        ERR_SUPPORT_FLAG_INVALID_VALUE: "Invalid value to enable Support.",
        ERR_SUPPORT_TEXT_REQUIRED: "Please write your question.",
        ERR_SUPPORT_TEXT_TOO_LONG: "Your question cannot exceed 2000 characters.",
        ERR_SUPPORT_INVALID_TICKET: "The ticket provided is not valid.",
        ERR_SUPPORT_INVALID_CONTACT: "The contact provided is not valid.",
        ERR_SUPPORT_INVALID_WHATSAPP: "The connection provided is not valid.",
        ERR_SUPPORT_TICKET_NOT_FOUND: "We could not find that ticket in your company.",
        ERR_SUPPORT_CONTACT_NOT_FOUND: "We could not find that contact in your company.",
        ERR_SUPPORT_WHATSAPP_NOT_FOUND: "We could not find that connection in your company.",
        ERR_SUPPORT_RATE_LIMIT: "You sent many questions in a short time. Please try again later.",
        ERR_SUPPORT_REQUEST_NOT_FOUND: "We could not find that question.",
        ERR_SUPPORT_REQUEST_CLOSED: "This question is closed. If you need anything else, open a new one.",
        ERR_SUPPORT_TOO_MANY_ATTACHMENTS: "You can attach up to 3 images per question.",
        ERR_SUPPORT_ATTACHMENT_TOO_LARGE: "Each image can be up to 5 MB.",
        ERR_SUPPORT_ATTACHMENT_INVALID_TYPE: "Only PNG, JPG or WebP images are accepted.",
        ERR_SUPPORT_ATTACHMENT_NOT_FOUND: "We could not find that image.",
        ERR_SUPPORT_INVALID_PAYLOAD: "We could not read the form. Please try again.",
        ERR_CRM_NEEDS_ACTIVE_STATES: "The Funnel needs at least one active contact state.",
        ERR_ENTRY_STAGE_MUST_BE_ACTIVE: "Only an active stage can be the Funnel entry stage.",
        ERR_LOST_REASON_NOT_FOUND: "The selected lost reason does not exist.",
        ERR_INVALID_SETTING_VALUE: "Invalid setting value.",
        ERR_INVALID_PARAM: "Invalid parameter.",
        // feat_210 estándar — motor + modo estándar/a medida + Excel modelo
        ERR_TEMPLATE_VAR_MISMATCH: "The template does not have the same number of variables as the send profile.",
        ERR_TEMPLATE_VARS_EXCEED_PROFILE: "The template has more variables than the send profile allows.",
        ERR_INVALID_HEADER_MATCH: "Invalid profile configuration: unknown header matching mode.",
        ERR_INVALID_TEXT_COLUMNS: "Invalid profile configuration: text columns are badly defined.",
        ERR_INVALID_PHONE_PARSER: "Invalid profile configuration: unknown phone parser.",
        ERR_INVALID_DEFAULT_COUNTRY: "Invalid profile configuration: default country not supported.",
        ERR_INVALID_REQUIRED_FOR_VAR: "Invalid profile configuration: requiredForVar must be an integer greater than or equal to 1.",
        ERR_INVALID_TEMPLATE_VARS_MODE: "Invalid profile configuration: unknown variables mode.",
        ERR_INVALID_MAX_VARS: "Invalid number of template variables.",
        ERR_NO_FREE_SLOT: "There is no free slot in Data Upload: all 4 are in use.",
        ERR_STANDARD_NOT_ENABLED: "The standard Excel is not enabled for this company.",
        ERR_INVALID_STANDARD_MODE: "Invalid data upload mode.",
        ERR_STANDARD_PROFILE_NOT_FOUND: "This company does not have the standard Excel enabled.",
        ERR_OUTBOUND_PAUSED: "Sending on this connection is PAUSED: the message was not sent. Resume it from Connections.",
        ERR_INVALID_PAUSED_VALUE: "Invalid value to pause sending.",
        // feat_299 — "Ver como usuario"
        ERR_VIEW_AS_INVALID_ID: "The user selected for \"View as\" is not valid.",
        ERR_VIEW_AS_REQUIRES_ADMIN: "Only an administrator can use \"View as user\".",
        ERR_VIEW_AS_USER_NOT_FOUND: "That user was not found in your company.",
        ERR_VIEW_AS_INVALID_TARGET: "You cannot view as another administrator.",
        ERR_PINNED_WHATSAPP_DISCONNECTED: "The connection assigned to this conversation is disconnected. Reconnect it to be able to reply.",
        ERR_OPT_IN_REQUIRED: "You must confirm the recipients' consent.",
        ERR_TEMPLATE_HEADER_VARS_NOT_SUPPORTED: "The template has variables outside the body (header or button), not supported.",
        ERR_TEMPLATE_HEADER_MEDIA_REQUIRED: "This template has a file in its header: attach the file to send it.",
        ERR_TEMPLATE_HEADER_MEDIA_NOT_SUPPORTED: "This template does not accept attachments: its header is text.",
        ERR_TEMPLATE_HEADER_MEDIA_TYPE_MISMATCH: "The file does not match the template's header type.",
        ERR_TEMPLATE_HEADER_MEDIA_UPLOAD_FAILED: "Could not upload the file to Meta. Please try again in a few minutes.",
        ERR_TEMPLATE_HEADER_MEDIA_SAMPLE_MISSING: "This template has an image/file header but Meta did not return its approved sample. Sync templates and try again.",
        ERR_TEMPLATE_HEADER_SAMPLE_REQUIRED: "Upload a sample file: Meta requires one to approve a template with a file header.",
        ERR_TEMPLATE_HEADER_SAMPLE_UPLOAD_FAILED: "Could not upload the sample file to Meta. Please try again in a few minutes.",
        ERR_BULK_IMPORT_IN_PROGRESS: "A bulk send is already in progress for this company.",
        ERR_WHATSAPP_NOT_CONNECTED: "The selected connection is not connected.",
        ERR_NOT_META_CONNECTION: "The selected connection is not a Meta connection.",
        ERR_TEMPLATE_NOT_APPROVED: "The template is not approved by Meta.",
        ERR_PROFILE_NOT_FOUND: "Send profile not found.",
        ERR_BULK_IMPORT_NOT_FOUND: "Bulk import not found.",
        ERR_BULK_IMPORT_NOT_CANCELLABLE: "The import cannot be cancelled in its current state.",
        ERR_BULK_IMPORT_NOT_RETRYABLE: "The import cannot be retried in its current state.",
        ERR_META_CONSECUTIVE_FAILURES: "The import was paused due to consecutive Meta failures.",
        ERR_META_BILLING_MISSING: "Could not send: payment method missing in Meta. Add a card in the Billing Center.",
        ERR_WHATSAPP_NOT_FOUND: "Connection not found.",
        ERR_TEMPLATE_NOT_FOUND: "Template not found.",
        ERR_FILE_REQUIRED: "File is required.",

        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_TICKET_LOCKED_BY_OTHER_AGENT: "This ticket is being attended by another advisor. You can't write.",
        ERR_REQUIRES_SUPER_SUPERADMIN: "Only the main superadmin can perform this action.",
        ERR_COMPANY_OUT_OF_SCOPE: "This company does not belong to your brand.",
        ERR_FEATURE_NOT_ALLOWED: "You don't have permission to access this section.",
        ERR_CANNOT_CHANGE_INSTANCE_ID: "You cannot change a company's brand outside of yours.",
        ERR_RESELLER_HAS_NO_WHITELABEL: "This reseller has no brand assigned.",
        ERR_INVALID_TARGET_COMPANIES: "You can only send announcements to companies of your brand.",
        ERR_TEMPLATE_VARS_MISMATCH: "Missing examples: provide one example for each template variable.",
        ERR_TEMPLATE_VARS_SEQUENCE: "Variables must be sequential starting at {{1}} (no gaps).",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_USER_EMAIL_EXISTS: "This email is already registered in this company.",
        ERR_PHONE_MASKED: "A masked phone number cannot be used.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_META_INVALID_CREDENTIALS:
          "Invalid Meta credentials. Check your Access Token and Phone Number ID.",
        ERR_META_WINDOW_EXPIRED:
          "24-hour window expired. The customer must write first.",
        ERR_META_NUMBER_NOT_WA:
          "This number does not have an active WhatsApp account.",
        ERR_WHATSAPP_ALREADY_LINKED:
          "This connection is already linked to another. Unlink first.",
        ERR_META_PHONE_ALREADY_LINKED:
          "This Meta number is already connected in another company. The same number cannot be in two companies.",
      },
      errors: {
        metaWindowExpired: "⚠️ 24-hour window expired. The customer must write first to resume the conversation, or use a template to start it.",
      },
    },
  },
};

export { messages };
